import React, { useState, useCallback, useEffect } from "react";
import Filter from "../../components/Filter/Filter";
import {
    fetchAPIData,
    getCompanyId,
    getToken,
    getUser,
    //compareNameIgnoreCase,
    copyToClipboard,
    cleanObject,
    generateHiddenColumns,
    hideSecret,
    HIDDEN_SECRET,
    hasPermission,
    platformManage,
    platformPermissionOptions,
    createFilterOptions, createSortFieldOptions
} from '../../Utils/Common';
import { handleSave } from '../../components/FormDialog/FormDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import Table, { renderCellExpand } from '../../components/Table/Table';
import { GridActionsCellItem } from "@mui/x-data-grid";
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import ActionDialog from "../../components/Dialogs/ActionDialog";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import axios from 'axios';
import "../pages.scss";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import { usePermissionContext } from "../../contexts/permission-context";

import Ajv from "ajv";
import ConnectorConfigPropertiesPanel from './ConnectorConfigPropertiesPanel';
const connectorSchemaRequired = require("../../json/connectorSchema.json").create.required;
const connectorSchemaOptional = require("../../json/connectorSchema.json").create.optional;
const connectorSchemaUpdate = require("../../json/connectorSchema.json").update;

const ajv = new Ajv({ strict: false });

const uiSchema = {
    "clientSecret": {
        "ui:widget": "password",
        "ui:autocomplete": "new-password"
    },
    "clientId": {
        "ui:autocomplete": "off"
    },
    "emailIds": {
        "ui:options": {
          orderable: false
        }
    },
};

const ConnectorConfigsTabPanel = ({ setNotify, openConnectorConfig, setOpenConnectorConfig }) => {
    const { permissions } = usePermissionContext();
    const [apiData, setApiData] = useState([]);
    const [rowJsonData, setRowJsonData] = useState({});
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    const [readOnly, setReadOnly] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmProps, setConfirmProps] = useState({});

    const [originalClientSecret, setOriginalClientSecret] = useState(""); // store original client secret

    useEffect(() => {
        if (openConnectorConfig) {
            createConnectorConfigData();
        }
    }, [openConnectorConfig]);

    const [connectorConfig, setConnectorConfigs] = usePersistentStorage("connectorConfig", []);

    useEffect(() => {
        // check if localstorge had data for the current tab
        setApiData(connectorConfig);
      },[]);

    const formId = 'ConnectorConfigDialog';

    const [reload, setReload] = useState(false);

    const [isLoading, setIsloading] = useState(false);

    const DEFAULT_COMPANY_ID = getCompanyId(); // make company dynamic

    const apiURL = `api/companies/${DEFAULT_COMPANY_ID}/connectors/configs?`;

    const totalLabel = "Matching Configs";
    const saveButtonText = "Save Connector";

    const fieldData = [
        'configId', 'clientId', 'emailIds', 'connectionType', 'baseUrl',
        'path', 'oauthUrl', 'createdDate', 'modifiedDate'
    ];

    const hasPlatformManage = hasPermission(permissions, platformManage);
    
    // note: label is no longer used. Filter component only uses field value
    const sortFieldData = [
        // {
        //     field: 'companyId',
        //     label: 'Company ID'
        // },
        {
            field: 'configId',
            label: 'Config ID'
        },
        {
            field: 'emailIds',
            label: 'Email ID'
        },
        {
            field: 'clientId',
            label: 'Client ID'
        },
        {
            field: 'connectorType',
            label: 'Connector Type'
        },
        {
            field: 'baseUrl',
            label: 'Base URL'
        },
        {
            field: 'path',
            label: 'Path'
        },
        {
            field: 'oauthUrl',
            label: 'OAuth URL'
        },
        {
            field: 'createdDate',
            label: 'Created Date'
        },
        {
            field: 'modifiedDate',
            label: 'Modified Date'
        }
    ];


    const columns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            hideable:false,
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            getActions: (params) => getActionButtons(params)
        },
        {
            hideable:false,
            field: 'configId',
            headerName: 'Config ID',
            minWidth: 300,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            // renderCell: renderCellExpand,
            renderCell: (params) => {
                return (

                    <div className="guidContent">
                        <div style={{ width: '255px' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy config id" onClick={(event) => copyToClipboard(event, params.row.configId)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            hideable:false,
            field: 'companyId',
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },

        {
            hideable:false,
            field: 'connectorType',
            headerName: 'Connector',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'baseUrl',
            headerName: 'Base URL',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (

                    <div className="clipboardContent">
                        <div style={{ width: '60px' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy base url" onClick={(event) => copyToClipboard(event, params.row.baseUrl)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            hideable:false,
            field: 'path',
            headerName: 'Path',
            minWidth: 325,
            //maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (

                    <div className="clipboardContent">
                        <div style={{ width: '275px', wordBreak: 'break-word'}}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy path" onClick={(event) => copyToClipboard(event, params.row.path)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            hideable:false,
            field: 'region',            // ????
            headerName: 'Region (AWS)',
            minWidth: 125,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'clientId',
            headerName: 'Client ID/User',
            minWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,           // formatter needed
        },
        {
            hideable:false,
            field: 'ingestionMode',
            headerName: 'Ingestion Mode',
            minWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'cspTenantUrl',
            headerName: 'CSP Tenant',
            minWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (

                    <div className="clipboardContent">
                        <div style={{ width: '180px', wordBreak: 'break-word' }}>
                            <a style={{ cursor: 'pointer' }} href={params.value} target="_blank" rel="noreferrer">{params.value}</a>
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy path" onClick={(event) => copyToClipboard(event, params.row.cspTenantUrl)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            hideable:false,
            field: 'cspRepositoryPath',
            headerName: 'CSP Tenant Repository',
            minWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (


                    <div className="clipboardContent">
                        <div style={{ width: '200px', wordBreak: 'break-word' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy path" onClick={(event) => copyToClipboard(event, params.row.cspRepositoryPath)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            hideable:false,
            field: 'documentType',
            headerName: 'Document Type',
            minWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'emailIds',
            headerName: 'Email ID',
            minWidth: 320,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                  <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
                    {params.value && params.value.map((item) => <>{item}<br /></>)}
                  </div>
                );
              },
        }

    ];

    const getColumns = () => {
        return (hasPlatformManage && columns) || columns.filter(obj => { return obj.field !== "actions"});
    };

    const toggleColumnPinning = () => {
        return (hasPlatformManage && 'columnPinning') || '';
    };

    const fetchData = async (apiURL2, qparams) => {
        //console.log('inside fetch customer data:', qparams);

        /*
        let message = "Loading customer data ...";
    
        setNotify({
            isOpen: true,
            message: message,
            severity: 'info'
        });
    */
        setIsloading(true);
        await fetchAPIData(apiURL2, qparams)
            .then((data) => {
                //console.log("Updating table data: ", data);
                setApiData(data);
                setConnectorConfigs(data);
                // clear the reload false now that data is loaded
                setReload(false);
                setIsloading(false);
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load connector config data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                // clear data since user may have previously loaded data that is already displayed
                setApiData([]);
                setReload(false);
                
            });

        //console.log("exiting company fetch data");
    };

    const createConnectorConfigData = () => {
        let rowData = {};
        const JsonData = rowData;
        
        setRowJsonData(JsonData);

        setMode('create');

        setOpen(true);
        setReadOnly(false);
    };

    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        setOriginalClientSecret(JsonData.clientSecret);

        let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

        formattedData.clientSecret = hideSecret(formattedData.clientSecret);

        setRowJsonData(formattedData);
        setMode('view');
        setReadOnly(true);
        setOpen(true);
    };

    const viewEditData = useCallback((rowData) => () => {
        // console.log("view/edit icon clicked", rowData);

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = rowData;

        setOriginalClientSecret(JsonData.clientSecret);

        let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

        formattedData.clientSecret = hideSecret(JsonData.clientSecret);

        setRowJsonData(formattedData);
        setMode('edit');
        setReadOnly(false);
        setOpen(true);
    }, []);

    const deleteConnectorConfig = (companyId, configId) => {

        let deleteUrl = `/api/companies/${companyId}/connectors/configs/${configId}`;

        axios({
            method: "delete", url: deleteUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {

                let message = `Deleted connector config [${configId}]`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });

                setApiData([]);
                setReload(true);

            }).catch(error => {
                console.log('error in delete connector config api call:', error);

                let message = `Failed to delete connector config [${configId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });
    };


    const deleteConnectorConfigData = useCallback((rowData) => () => {
        // console.log("delete connector config icon clicked", rowData);

        let title = "Delete Connector Config";
        let msg = `The connector config ${rowData.configId} will be removed. Are you sure?`;

        let configId = rowData.configId;
        let companyId = rowData.companyId;

        let confirmProps = {
            title,
            msg,
            confirmCallback: () => deleteConnectorConfig(companyId, configId)
        };

        setConfirmProps(confirmProps);

        setConfirmOpen(true);
    }, []);

    const getActionButtons = (params) => {
        let actionButtons = [];


        // create edit button
        let editButton = <GridActionsCellItem icon={
            <Tooltip title="Edit Config" arrow placement="right">
                <EditIcon />
            </Tooltip>}
            label='View/Edit'
            onClick={viewEditData(params.row)}
        />;

        hasPlatformManage && actionButtons.push(editButton);

        let deleteButton = <GridActionsCellItem icon={
            <Tooltip title="Delete Config" arrow placement="right">
                <DeleteIcon />
            </Tooltip>}
            label='Delete'
            onClick={deleteConnectorConfigData(params.row)}
        />;

        hasPlatformManage && actionButtons.push(deleteButton);

        return actionButtons;

    };

    const handleJsonChange = (formData) => {
        setRowJsonData(formData);
    };

    const handleClose = () => {
        setOpen(false);

        setOpenConnectorConfig(false);
    };

    const handleFormChange = (data) => {
        setRowJsonData(data.formData);
    }

    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const validateSchema = (connectorSchema, data) => {
        // console.log('got json schema', connectorSchema);
        const validate = ajv.compile(connectorSchema);
        const valid = validate(data);
        if (!valid) {
            console.log(validate.errors);
            return false;
        }
        return true;
    }

    const saveConnectorConfigData = (formData) => {

        // console.log('called save connector config:', formData);
        // console.log('current mode:', mode);

        let cleanedObj = cleanObject(formData);

        if (mode === 'edit') {
            if (validateSchema(connectorSchemaUpdate, cleanedObj)) {
                //call save API
                // console.log('validated successfully..');
                updateConnectorConfig(cleanedObj);
            }
        }

        if (mode === 'create') {
            if (validateSchema(connectorSchemaRequired, cleanedObj)) {
                if (validateSchema(connectorSchemaOptional, cleanedObj)) {
                    // console.log('create schema validated successfully..');
                    createConnectorConfig(cleanedObj);
                }
                else {
                    console.log('create schema validation failed for optional params..');
                    let message = `Create connector config schema validation failed for optional parameters`;

                    setNotify({
                      isOpen: true,
                      message: message,
                      severity: 'error'
                    });
                }
            }
            else {
                console.log('create connector config schema validation failed..');
                let message = `Create connector config schema validation failed`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'error'
                });
            }

            // reset flag all the time on success or failure
            setOpenConnectorConfig(false);
        }
    };


    const createConnectorConfig = (data) => {
        try {
            // console.log('inside connector config create api..');

            let createUrl = `/api/companies/${data.companyId}/connectors/configs`;

            axios({
                method: "post",
                url: createUrl,
                data: data,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        //console.log('got response from connector config create:', response);

                        let message = `Created connector config [${response.data.configId}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        // refresh the table
                        setReload(true);
                        setOpen(false);
                    }
                }).catch(error => {
                    let message = `Failed to create connector config \n\n ${error.response.statusText} : ${error.response.data.message}`;

                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });

                    console.log('error in create connector config api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);
            let message = `Failed to create connector config`;

            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        }
    };


    const updateConnectorConfig = (data) => {
        try {
            // console.log('inside connector config update api..');

            let updateUrl = `/api/companies/${data.companyId}/connectors/configs/${data.configId}`;

            // password not changed so send original client secret
            if (data.clientSecret === HIDDEN_SECRET) {
                data.clientSecret = originalClientSecret;
            }

            axios({
                method: "put",
                url: updateUrl,
                data: data,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        let message = `Updated connector config [${data.configId}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        // console.log('got response from connector config update:', response);
                        // refresh the table
                        setReload(true);
                        setOpen(false);
                    }

                }).catch(error => {

                    let message = `Failed to update connector config data \n\n ${error.response.statusText} : ${error.response.data.message}`;
                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });
                    console.log('error in update connector config api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);

            let message = `Failed to update connector config data `;
            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        }
    };



    return (
        <>
            <div id="connectorConfigfilterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
                <Filter permission={platformPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL={apiURL} fetchData={fetchData} setNotify={setNotify} reload={reload} useCompanyId={false} totalLabel={totalLabel} tabName={'connectorConfigTab'} />
            </div>


            <Divider />

            <div id="connectorConfigTableContainer" className={toggleColumnPinning()}>
                <div >
                    <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
                </div>
            </div>


            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                onSave={() => handleSave(formId, rowJsonData, saveConnectorConfigData)}
                title="Connector Config Information"
                propertiesTabContent={
                    <ConnectorConfigPropertiesPanel formId={formId}
                        uiSchema={uiSchema}
                        connectorConfigSchemaRequired={connectorSchemaRequired}
                        connectorConfigSchemaOptional={connectorSchemaOptional}
                        saveConnectorConfigData={saveConnectorConfigData}
                        formData={rowJsonData} handleFormChange={handleFormChange}
                        readOnly={readOnly} />
                }
                jsonDataName="connector config"
                JSONTabContent={rowJsonData}
                handleJsonChange={handleJsonChange}
                saveButtonText={saveButtonText}
            />

            <ConfirmDialog
                title={confirmProps.title}
                open={confirmOpen}
                onClose={handleConfirmClose}
                setOpen={setConfirmOpen}
                cancelButtonText={confirmProps.cancelButtonText}
                confirmButtonText={confirmProps.confirmButtonText}
                onConfirm={confirmProps.confirmCallback}
            >
                {confirmProps.msg}
            </ConfirmDialog>

        </>
    );
}

export default ConnectorConfigsTabPanel;